import React from "react";
import LoadingSkeleton from "../general/skeleton";
import clsx from "clsx";
import { Info } from "lucide-react";
import { ToolTip } from "./toolTip";

export const SimpleCard = ({ data, loading, hidden }) => {

  return (
    <LoadingSkeleton loading={loading} className="h-[120px]">
      <div
        className={clsx(
          "h-full w-full flex-1 relative px-3 py-3 rounded-2xl font-nexa flex flex-col justify-between overflow-hidden",
          data.bgColor ? data.bgColor : "bg-white"
        )}
        data-testid={`simple-card-${data.title}`}
      >
        <div className="flex-col flex-1 justify-between h-full items-center relative">
          {/* Header */}
          <div className="grid grid-cols-3 gap-0 mb-2 sm:mb-2 w-full relative">
            <div className="flex items-center gap-1 col-span-2 justify-start">
            <p className="font-nexa text-sm sm:text-sm md:text-md text-primary-title leading-5 mb-0 overflow-hidden truncate">
              {data?.title}
            </p>

            {/* Info Icon Popover */}
            {data?.showInfo && (
              <ToolTip content={data?.tip || data?.title}>
                <Info size={14} className="text-gray-500 hover:text-primary cursor-pointer" />
              </ToolTip>
            )}
          </div>


            {/* Right Icon */}
            {data?.icon && (
              <data.icon className="hidden sm:block sm:size-6 md:size-6 lg:size-8 absolute right-2 top-2 text-primary-dark mt-2 sm:mt-0" />
            )}
          </div>

          {/* Content */}
          <div className="grid grid-cols-1 gap-2 w-full">
            <p className={clsx("font-nexa font-bold text-sm sm:text-md md:text-lg text-primary-dark leading-2 mb-0 text-wrap", hidden && "blur-sm")}>
              {data?.value}
            </p>
            <p className={clsx("font-nexa text-xs sm:text-sm md:text-base text-subText mt-0", hidden && "blur-sm")}>
              {data?.subText}
            </p>
          </div>
        </div>
      </div>

      {/* Tooltip rendered via Portal */}
      {/*  */}
    </LoadingSkeleton>
  );
};
// import React from "react";
// import LoadingSkeleton from "../general/skeleton";
// import clsx from "clsx";
// import { Info } from "lucide-react";
// import { ToolTip } from "./toolTip";

// export const SimpleCard = ({ data, loading }) => {

//   return (
//     <LoadingSkeleton loading={loading} className="h-[120px]">
//       <div
//         className={clsx(
//           "h-full w-full flex-1 relative px-3 py-3 rounded-2xl font-nexa flex flex-col justify-between overflow-hidden",
//           data.bgColor ? data.bgColor : "bg-white"
//         )}
//         data-testid={`simple-card-${data.title}`}
//       >
//         <div className="flex-col flex-1 justify-between h-full items-center relative">
//           {/* Header */}
//           <div className="grid grid-cols-3 gap-0 mb-2 sm:mb-2 w-full relative">
//             <div className="flex items-center gap-1 col-span-2 justify-start">
//             <p className="font-nexa text-sm sm:text-sm md:text-md text-primary-title leading-5 mb-0 overflow-hidden truncate">
//               {data?.title}
//             </p>

//             {/* Info Icon Popover */}
//             {data?.showInfo && (
//               <ToolTip content={data?.tip || data?.title}>
//                 <Info size={14} className="text-gray-500 hover:text-primary cursor-pointer" />
//               </ToolTip>
//             )}
//           </div>


//             {/* Right Icon */}
//             {data?.icon && (
//               <data.icon className="hidden sm:block sm:size-6 md:size-6 lg:size-8 absolute right-2 top-2 text-primary-dark mt-2 sm:mt-0" />
//             )}
//           </div>

//           {/* Content */}
//           <div className="grid grid-cols-1 gap-2 w-full">
//             <p className="font-nexa font-bold text-sm sm:text-md md:text-lg text-primary-dark leading-2 mb-0 text-wrap">
//               {data?.value}
//             </p>
//             <p className="font-nexa text-xs sm:text-sm md:text-base text-subText mt-0">
//               {data?.subText}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Tooltip rendered via Portal */}
//       {/*  */}
//     </LoadingSkeleton>
//   );
// };
